import React, { Component } from 'react';
import HorizontalLayout from './component/HorizontalLayout';
import VerticalLayout from './component/VerticalLayout';
import MutiIconLayout from './component/MutiIconLayout';
import { homeMoudleData,homeLightweight,homeMultiFormat,homeFullPort }from '../common/config/homeJson';
import './home.less'

export default class Home extends Component {
  constructor(props) {
    super(props)
  }

  render() {
      return (
        <div className="home main">
          <div className="moudle">
            {
              (homeMoudleData||[]).map((item,index)=>{
                return (
                    <HorizontalLayout moduleInfo={item} key={index} type={ item.key%2 === 0 ?'rightword':'leftword'}/>
                )
              })
            }  
          </div>
          <div className="lightWeight">
               <h2 className="con-title">{homeLightweight.title}</h2>
               <p className="con-caption">{homeLightweight.caption}</p>
               <p className="con-caption caption2">{homeLightweight.caption2}</p>
               < MutiIconLayout info={ homeLightweight.data}/>

          </div>
          <div className="multiFormat hasBg">
                <h2 className="con-title">{homeMultiFormat.title}</h2>
                <p className="con-caption">{homeMultiFormat.caption}</p>
                <ul className="format-list">
                  {
                    homeMultiFormat && homeMultiFormat.formats.map((item, index) => {
                      return (
                        <li key={index}>
                            <img className="format-logo" src={ item.imgHref } alt={ item.title } />
                            <div className="format-name">{ item.title }</div>
                        </li>)
                    })
                  }
               </ul>
          </div>
          <div className="fullPort">
                <VerticalLayout moduleInfo={homeFullPort}/>
          </div>

        </div>)
  }
}


